export enum PRODUCT_TYPE {
    box = 'Box',
}

export const excludedProductTypes: (PRODUCT_TYPE | string)[] = [PRODUCT_TYPE.box];
